import { render, staticRenderFns } from "./calssesDashbord.vue?vue&type=template&id=4bffe631&"
import script from "./calssesDashbord.vue?vue&type=script&lang=js&"
export * from "./calssesDashbord.vue?vue&type=script&lang=js&"
import style0 from "./calssesDashbord.vue?vue&type=style&index=0&id=4bffe631&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports